export function normalizeDirection(x: number, y: number): { x: number; y: number } {
  const length = Math.hypot(x, y);
  return length > 0 ? { x: x / length, y: y / length } : { x: 0, y: 0 };
}

export function directionFromPoints(
  originX: number,
  originY: number,
  targetX: number,
  targetY: number,
  deadZone: number,
  fullStrengthDistance = deadZone,
): { x: number; y: number } {
  const dx = targetX - originX;
  const dy = targetY - originY;
  const distance = Math.hypot(dx, dy);
  if (distance <= deadZone) return { x: 0, y: 0 };
  const direction = normalizeDirection(dx, dy);
  const strength = Math.min(1, (distance - deadZone) / Math.max(1, fullStrengthDistance - deadZone));
  return { x: direction.x * strength, y: direction.y * strength };
}
